export default {
    /**
     * The default height for the all day well when collapsed
     */
    defaultAllDayWellCollapsedHeight: 158,
};
